import axios from 'axios'
export default {
  methods: {
    rec_paises_departamentos () {
      this.loadingDepartamento = true
      this.items_departamentos = []
      var urlroute = this.$store.getters.getUrl + 'departamentos'
      axios({
        url: urlroute,
        method: 'GET',
        data: null,
        auth: {
          username: this.$store.getters.getHeadUsuario,
          password: this.$store.getters.getHeadPassword
        }
      }).then(response => {
        this.items_departamentos = response.data
      }).catch(error => {
        console.log('error ' + error)
      }).finally(() => {
        this.loadingDepartamento = false
      })
    },
    rec_paises_ciudades (pDepartamentoId) {
      this.loadingCiudad = true
      this.items_ciudades = []
      var urlroute = this.$store.getters.getUrl + 'paises_ciudades/' + pDepartamentoId
      axios({
        url: urlroute,
        method: 'GET',
        data: null,
        auth: {
          username: this.$store.getters.getHeadUsuario,
          password: this.$store.getters.getHeadPassword
        }
      }).then(response => {
        this.items_ciudades = response.data
      }).catch(error => {
        console.log('error ' + error)
      }).finally(() => {
        this.loadingCiudad = false
      })
    }

  }
}
